<template>
    <div class="row">
        <div class="col-md-12 form-group">
            <h4> ยินดีต้อนรับเข้าสู่ระบบ </h4>
        </div>
        <div class="col-md-12 h5">
            ผู้ใช้งาน : {{ getAuthen.typename }} {{ getAuthen.orgcode }}
            <br>{{ getAuthen.orgname }}
            <br>{{ getAuthen.register_name }}
        </div>
        <div class="col-md-12 form-group text-center" style="margin-top: 20px">
            <input v-on:click="clickButtonLogout"
                   id="btn_logout"
                   name="btn_logout"
                   type="button"
                   class="btn btn-primary btn-sm"
                   value="ออกจากระบบ" >
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'

    export default {
      data: function () {
        return {
        }
      },
      methods: {
        ...mapActions([
          'clickButtonLogout'
        ])
      },
      computed: {
        /* getAuthen () {
          return this.$store.getters.getAuthen
        } */
        ...mapGetters([
          'getAuthen'
        ])
      }
    }
</script>



// WEBPACK FOOTER //
// LoginInfo.vue?cf2c6ce4